import { useMemo } from "react";

import { ChatBotSessionIdSchema } from "@fartherfinance/frontend/api/Chatbot/schemas";

export const useGetIsValidSessionid = (sessionId: string | null): boolean => {
  const isValidSessionId = useMemo(() => {
    return ChatBotSessionIdSchema.safeParse(sessionId).success;
  }, [sessionId]);

  return isValidSessionId;
};
